import React from "react";
import Typography from "@mui/material/Typography";
import { TextField } from "@mui/material";
import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import { formatUSDate, formatUSDateTime } from "../../../../pages/utils/date.utils";
import { DueDateContext } from "../../../../contexts/DueDateContext";

const DueDate = () => {
  const { windowCloses, windowStatus, nextWindowOpens } = React.useContext(DueDateContext);
  return (
    <Box display="flex" alignItems="center" margin="25px 0 25px 50px">
      <Typography display={"inline-block"} marginRight="8px">
        Due by 3rd Business day of the month:
      </Typography>
      <TextField
        variant="filled"
        disabled
        value={formatUSDateTime(windowCloses)}
        sx={{
          ".MuiInputBase-input": {
            width: "200px",
            paddingTop: "10px",
            paddingRight: "5px"
          },
        }}
      />
      <Tooltip data-testid="window-status-tooltip" title={ "Current window is " + windowStatus +
          ". Next month's window opens " + formatUSDateTime(nextWindowOpens)}>
      <Typography data-testid="window-status" variant="button" fontSize="2em" color={windowStatus == "OPEN" ? "green" : "red"}
                  marginLeft="20px" paddingLeft="10px" borderTop="5px" borderBottom={"5px"}>
          {windowStatus}
      </Typography>
      </Tooltip>
    </Box>
  );
};
export default DueDate;
